import { Component, OnInit,Renderer2,ElementRef,ViewChild  } from '@angular/core';
import { LoaderService } from '../../service/loader.service';
import { ChartService } from '../../service/chart.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ReportAnalyticsService } from '../../service/report-analytics.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
//import { Console } from 'console';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-service-performance',
  templateUrl: './service-performance.component.html',
  styleUrls: ['./service-performance.component.scss']
})
export class ServicePerformanceComponent extends BaseComponent implements OnInit {
   @ViewChild('chartContainer', { static: true }) chartContainer!: ElementRef;
  items = [];
  //rawHtml:string="";
  chartData: number[]=[];
  chartLabel: string;
  colorIndex: number=0;
  public barChartLabels:string[] =[]
  public barChartData:any[] =[];
  public barChartType:string = 'horizontalBar';
  public barChartLegend:boolean = false;
  public barChartColors:Array<any> = [];


  // public barChartOptions:any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
 
  // };

  
public barChartOptions: any = {
  scaleShowVerticalLines: false,
  responsive: true,
  // NEW: tooltip formatting to append "AED" to values
  tooltips: {
    callbacks: {
      label: function (tooltipItem, data) {
       
        const usFormatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        // Prefix with dataset label if present, then value + " AED"
        const dsLabel = data.datasets[tooltipItem.datasetIndex]?.label || '';
        // const value = tooltipItem.xLabel; // horizontalBar uses xLabel for value
        const value = usFormatter.format(tooltipItem.xLabel);
        // If you want only "765 AED" without dataset name, return `${value} AED`
         return dsLabel ? `${dsLabel}: ${value} AED` : `${value} AED`;
       
      }
    }
  }
};

    constructor( 
         private loaderService: LoaderService
        ,private chartService:ChartService
        ,private reportAnalyticsService:ReportAnalyticsService 
        ,private sanitizer: DomSanitizer
        ,private renderer: Renderer2
      )
      { 
        
        super();
      }

  ngOnInit(): void {
   // this.CreateChartSelectedDateWise() ;
  }
  



    
CreateChartSelectedDateWise() {
  this.chartContainer.nativeElement.innerHTML = '';
    if (this.items.length > 0) {
      this.reportAnalyticsService.GetServicePerformanceReport(
        this.items[0]["reportFromDate"],
        this.items[0]["reportToDate"],
        this.items[0]["period"],
        this.items[0]["year"],
        this.items[0]["month"],
        "ServicePerformanceReport"
      ).subscribe(ress => {
        this.loaderService.hide();
        if (ress.successed) {
          const data = ress.data;
          
          data.servicePerformanceTotalReport.forEach((_data, idx) => {

            this.colorIndex=idx;
            const canvasId = `chart-${_data.serviceId}`;

            // Create container div
            const box = this.renderer.createElement('div');
            this.renderer.addClass(box, 'dashboardContentBox');

            // Heading
            const heading = this.renderer.createElement('div');
            this.renderer.addClass(heading, 'dashboardContentBoxHeading');
            heading.innerHTML = _data.serviceName;
            this.renderer.appendChild(box, heading);

            // Body
            const body = this.renderer.createElement('div');
            this.renderer.addClass(body, 'dashboardContentBoxBody');

            
          const usFormatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });


            const revenue = this.renderer.createElement('div');
            this.renderer.addClass(revenue, 'status-card');
            // revenue.innerHTML = `Total Revenue : ${_data.totalRevenue} AED`;
             revenue.innerHTML = `Total Revenue : ${usFormatter.format(_data.totalRevenue)} AED`;
            
            this.renderer.appendChild(body, revenue);

            const order = this.renderer.createElement('div');
            this.renderer.addClass(order, 'status-card');
            order.innerHTML = `Total Order : ${_data.totalOrder}`;
            this.renderer.appendChild(body, order);

            const canvas = this.renderer.createElement('canvas');
            canvas.setAttribute('id', canvasId);
            canvas.setAttribute('width', '400');
            canvas.setAttribute('height', '200');
            this.renderer.appendChild(body, canvas);

            this.renderer.appendChild(box, body);
            this.renderer.appendChild(this.chartContainer.nativeElement, box);

            // Prepare chart data
            const chartLabels: string[] = [];
            
            const datasets: any[] = [];
                        

              const distinctImplementation = data.servicePerformanceChart.filter(
                (servicePerformanceChart, i, arr) => 
                  arr.findIndex(t => t.implementationName === servicePerformanceChart.implementationName
                  && t.serviceId === _data.serviceId) === i
              );

             
               distinctImplementation.forEach((item, id) => {
                   chartLabels.push(item.implementationName);
               });
               
              if(data.servicePerformanceChart[0].subColumnName !== "undefined" && data.servicePerformanceChart[0].subColumnName !== null){
                
                const distinctColumn = data.servicePerformanceChart.filter(
                  (servicePerformanceChart, i, arr) => arr.findIndex(t => t.columnName === servicePerformanceChart.columnName) === i
                );

                const distinctSubColumn = data.servicePerformanceChart.filter(
                (servicePerformanceChart, i, arr) => 
                  arr.findIndex(t => t.subColumnName === servicePerformanceChart.subColumnName
                  && t.serviceId === _data.serviceId) === i
              );

                
              distinctColumn.forEach((itemYear, idxYear) => {
                distinctSubColumn.forEach((itemMonth, idxMonth) => {
                  const chartValues: number[] = [];

                  distinctImplementation.forEach(impl => {
                    // console.log(" _data.serviceId", _data.serviceId,"itemYear.columnName ",itemYear.columnName
                    //   ,"itemMonth.subColumnName",itemMonth.subColumnName,"implementationName",impl);
                    const filteredData = data.servicePerformanceChart.find(item =>
                      item.serviceId === _data.serviceId &&
                      item.columnName === itemYear.columnName &&
                      item.subColumnName === itemMonth.subColumnName &&
                      item.implementationName === impl.implementationName
                    );
                   // console.log("filteredData",filteredData);
                    chartValues.push(filteredData ? filteredData.totalRevenue : 0);
                    
                  });

                  console.log("chartValues",chartValues);
                  datasets.push({
                    label: `${itemYear.columnName} ${itemMonth.subColumnName}`,                  
                    data: chartValues,
                    backgroundColor: this.chartService.getColors(datasets.length) // unique color per dataset
                  });
                });
              });


              }
              else if(data.servicePerformanceChart[0].columnName === "undefined" )
              {
                     
                  const chartValues: number[] = [];
                    distinctImplementation.forEach((itemImpl, id) => {
                        const filteredData = data.servicePerformanceChart.filter(
                          item => item.serviceId === _data.serviceId && 
                          //item.columnName===itemyear.columnName && 
                          item.implementationName === itemImpl.implementationName
                        );
                       
                      
                        chartValues.push(filteredData.length>0 ? filteredData[0].totalRevenue : 0 );
                    });
                 
       
                  datasets.push({
                      label: "DateRange",//this.items[0]["reportFromDate"]+" - " +this.items[0]["reportToDate"],
                      data: chartValues,
                      backgroundColor: this.chartService.getColors(1), // Different color per year
                    });

                  //console.log("chartValues",chartValues);
             
                
              }
              else
              {
                  const distinctColumn = data.servicePerformanceChart.filter(
                  (servicePerformanceChart, i, arr) => arr.findIndex(t => t.columnName === servicePerformanceChart.columnName) === i
                );
                  distinctColumn.forEach((itemyear, idxYear) => {
                  const chartValues: number[] = [];
                    distinctImplementation.forEach((itemImpl, id) => {
                        const filteredData = data.servicePerformanceChart.filter(
                          item => item.serviceId === _data.serviceId && 
                          item.columnName===itemyear.columnName && 
                          item.implementationName === itemImpl.implementationName
                        );
                      
                        chartValues.push(filteredData.length>0 ? filteredData[0].totalRevenue : 0 );
                    });
                 
                  console.log("chartValues=================",chartValues);
                  datasets.push({
                      label: itemyear.columnName,
                      data: chartValues,                      
                      backgroundColor: this.chartService.getColors(idxYear),
                       // Different color per year
                    });

                    this.barChartOptions

                  //console.log("chartValues",chartValues);
              });

              }                
           
            
            //console.log("datasets",datasets);
            // Initialize Chart
            setTimeout(() => {
              const ctx = document.getElementById(canvasId) as HTMLCanvasElement;
              if (ctx) {
                new Chart(ctx, {
                  type: 'horizontalBar',
                  data: {
                    labels: chartLabels,
                    datasets: datasets
                  
                   },
                  options: this.barChartOptions
                });
              }
            }, 100); // Slight delay to ensure DOM is ready
          });
        } else {
          this.toastrAlertService.errorToastr(ress.errorMessage);
        }
      }, error => {
        this.loaderService.hide();
        this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
      });

      this.items = [];
    }
}




  addItem(newItem: string) {     
  this.items.push(newItem);   
    this.CreateChartSelectedDateWise();
  }


  public chartClicked(e:any):void {
      //console.log(e);
    }

  public chartHovered(e:any):void {
      console.log(e);
    }
  
}
